module.exports = __webpack_public_path__ + "img/kha.481a7ef.jpg";